import React from 'react';
import moment from "moment";
import { openErrorAlert } from '../../rigiUtils.js';
import ChangePasswordForm from '../forms/validated/ChangePasswordForm.jsx';
import { logout } from '../../services/rigiUserService';
import { withRigiContext } from "../context/rigiContext"
import { withForegroundContext } from "../context/ForegroundContext"

class Footer extends React.Component {

	constructor() {
        super();
        this.logoutRigiUser = this.logoutRigiUser.bind(this);
	}

	logoutRigiUser() {
        try {
            let onSuccessCallback = () => {this.props.rigiContext.updateRigiUser(null)}
            logout(onSuccessCallback)
        } catch (e) {
            // TODO error alert not working (foreground context in class component?)
            openErrorAlert(e.message);
        }
    }
    
	render() {
		return (
			<div className="footer">
                <div className="content">
                    <div className="user">
                        <p>
                            <span onClick={() => this.props.foregroundContext.openModal("Passwort ändern", <ChangePasswordForm/>)}>
                                Passwort ändern
                            </span>
                        </p>
                        <p>
                            <span onClick={this.logoutRigiUser}>Logout</span>
                        </p>
                    </div>
                    <div className="tinystudio">
                        © {moment().format('YYYY')} by <a href="http://www.tinystudio.ch">Tinystudio</a>
                    </div>
                </div>
            </div>
		);
	}
}

export default withRigiContext(withForegroundContext(Footer));